import { render, staticRenderFns } from "./TempAccountDelete.vue?vue&type=template&id=679c183c"
import script from "./TempAccountDelete.vue?vue&type=script&lang=ts"
export * from "./TempAccountDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports